<template>
    <div class="chart-inner" ref="numberChart">
    </div>
</template>

<script>
  /* eslint-disable */
  import * as d3 from 'd3'

  export default {
    props: {
      textValue: {type: String},
      trend: [Array, Object]
    },
    data() {
      return {
      }
    },
    watch: {
      numberVal(newVal) {
        this.$refs.numberChart.innerHTML = ''
        this.draw()
      }
    },
    mounted() {
      this.draw()
    },

    methods: {
      draw() {
        const tau = 2 * Math.PI;
        const element = this.$el
        const width = 550
        const height = 400
        const radius = width / 2
        const viewBox = `0 0 ${width} ${height}`
        const fontSize = width/4.2;

        const svg = d3.select(element)
          .append('svg')
          .attr('viewBox', viewBox)

        const g = svg.append("g")
          .attr('transform', `translate(${width / 2}, ${height / 2})`)

        let text = g.append("text")
          .attr("class", "text")
          .attr("text-anchor", "middle")
          .style("font-size",fontSize/1.5+'px')
          .style("font-weight", 'regular')
          .attr("dy",width)

        const word = this.textValue.split(" ")
        word.forEach((element, i) => {
          text.append("tspan")
            .attr("x", 0)
            .attr("dy", i +"em")
            .text((d) => {
              return element;
            })
        })
      }
    }
  }
  /* eslint-enable */
</script>

<style lang="sass">
  @import '../../../styles/helpers/_mixins.sass'
  @import '../../../styles/base/variables'


  .chart-inner
    cursor: pointer
          
  .text
    fill: $color-side-nav
  
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/charts/TextChart.vue